module.exports = __webpack_public_path__ + "img/capt_e.170cfca9.jpg";